import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-600 text-sm"></i>
            )}
            {item.to ? (
              <Link
                to={item.to}
                className="text-foreground-500 hover:text-primary-500 transition-colors duration-200"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-300 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: items.map((item, index) => ({
              '@type': 'ListItem',
              position: index + 1,
              name: item.label,
              item: item.to
                ? `https://hfcstore.cn${item.to}`
                : undefined,
            })),
          }),
        }}
      />
    </nav>
  );
}